import { render, staticRenderFns } from "./DeTok.vue?vue&type=template&id=cd85d2c0&scoped=true&"
import script from "./DeTok.vue?vue&type=script&lang=js&"
export * from "./DeTok.vue?vue&type=script&lang=js&"
import style0 from "./DeTok.vue?vue&type=style&index=0&id=cd85d2c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd85d2c0",
  null
  
)

export default component.exports